export default __webpack_public_path__ + "static/Cart-Filters-bb5302f021b13e81ea0bccb74ed0a44b.jpg";